import defineComponent from 'flight';

function SimilarItemsUI() {
    this.defaultAttrs({
        itemCardLink: '[data-item-card-body]'
    });

    this._trackNavigation = function (e, target) {
        let targetCategoryId = $(target.el).data('item-category-id');

        this.trigger(document, 'analytics:track-event', {
            category: 'View item',
            action: 'Navigation',
            label: 'Similar item - Category: ' + targetCategoryId
        });
    };

    this.after('initialize', function () {

        this.on('click', {
            itemCardLink: this._trackNavigation
        });

    });
}

module.exports = defineComponent.component(SimilarItemsUI);


// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/app/ui/view-item/similar-items.js